package com.evoapps.evoshift.domain.usecase.shift

import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.repository.ShiftRepository
// Twoja biblioteka czasu
import com.evoapps.evoshift.domain.util.AppClock.now

class CreateShiftUseCase(
    private val shiftRepository: ShiftRepository,
    /**
     * Prices a shift created for someone into its cost snapshot, as assigning does (without it the
     * shift had no snapshot, and its cost and hours were missing from the day until a refresh).
     * A pricing failure (no pay rates) never fails the creation.
     */
    private val calculateShiftCost: com.evoapps.evoshift.domain.usecase.CalculateShiftCostUseCase? = null
) {
    suspend operator fun invoke(shift: Shift): Result<String> {
        return try {
            // 1. Walidacja daty (czy nie w przeszłości? - opcjonalnie)
            // if (shift.date < today) ...

            // 2. Uzupełnij metadane (created_by, created_at)
            // Wartości te powinny być nadpisane przez UseCase, a nie UI, dla bezpieczeństwa
            // Zakładamy, że obiekt 'shift' przychodzi z UI częściowo wypełniony.

            // Tutaj można dodać logikę sprawdzania, czy user ma kompetencje do tej roli,
            // ale to często robi się przy 'AssignUser'.

            // 3. Zapisz
            shiftRepository.createShift(shift).onSuccess { id ->
                if (shift.userId != null) calculateShiftCost?.invoke(id)
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    /**
     * SH-169: creates [shifts] in one batched write (the grid's multi-select and paste) and returns
     * their ids in the same order; those created for someone are priced as one shift would be.
     */
    suspend fun many(shifts: List<Shift>): Result<List<String>> =
        shiftRepository.createShiftsWithIds(shifts).onSuccess { ids ->
            shifts.zip(ids).forEach { (shift, id) -> if (shift.userId != null) calculateShiftCost?.invoke(id) }
        }
}
